import React from "react";

const StyleButton = (props) => {
    const onToggle = (e) => {
        e.preventDefault();
        props.onToggle(props.style);
    };

    const className = props.active ? "button -pressed" : "button";

    return (
        <span className={className} onMouseDown={onToggle} title={props.label}>
            {props.icon}
        </span>
    );
};

export default StyleButton;
